/* global $:false */

export default class SidemenuFolder {
  static init () {
    Array.from($('.js-sidemenu-folder')).map((el) =>
      new SidemenuFolder(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.setupBindings()
  }

  findElements () {
    this.foldout = this.el.next()
  }

  setupBindings () {
    this.el.click(event => this.toggle(event))
  }

  toggle (event) {
    if (event != null) {
      event.preventDefault()
    }
    if (this.isOpen()) { this.close() } else { this.open() }
  }

  isOpen () {
    return this.foldout.is(':visible')
  }

  open () {
    this.el.addClass('open')
    this.foldout.show()
  }

  close () {
    this.el.removeClass('open')
    this.foldout.hide()
  }
}
